import { type PressableProps } from 'react-native';

/**
 * Pressable props enforcing a claim gate's block. The blocked overlay only
 * swallows pointer events, so on web a pressable underneath it stays
 * Tab-focusable and Enter activates it — the claim gate bypassed without the
 * "Edit anyway" step. Dropping the pressable from the tab order closes that
 * path; the overlay's own button stays tabbable, so the keyboard route to the
 * override toast survives. `disabled` closes the remaining route: a screen
 * reader's virtual cursor activates the element directly, reaching it past
 * both the overlay and the tab order.
 */
export function blockedPressableProps(
  blocked: boolean,
): Pick<PressableProps, 'disabled' | 'tabIndex'> {
  return { disabled: blocked, tabIndex: blocked ? -1 : 0 };
}
